module.exports = __webpack_public_path__ + "media/images/products-subnav-fd94aec935a38ee7c90296a98fcbb2b3.jpg";